import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../../components/form/DynamicForm';
import { Form, Validators } from '../../../../components/form/DynamicFormTs';
import Http from '../../../../Http';

class Destinatario extends FormComponent {

  // FILTRAR CIUDADES ON CHANGE ESTADO

  componentDidMount() {
    // console.log(this.props.match.params)
    this.FormConfig(
      { defaultUrl: 'cliente-destinatario/one', saveUrl: 'cliente-destinatario/save', backUrl: '/Catalogo/Cliente/' + this.props.match.params.id + '/Destinatarios' },
      new Form([
        // Form.Field('text', 'cliente_dests', 'Clave', '', [Validators.required], 2),
        Form.Field('text', 'cliente_dests_nombre', 'Nombre', '', [Validators.required, Validators.maxLength(64)], 12),
        Form.Field('text', 'cliente_dests_telefono', 'Teléfono', '', [Validators.required, Validators.maxLength(31)], 6),
        Form.Field('number', 'cliente_dests_cp', 'C.P.', '', [Validators.required], 6),
        Form.Field('autocomplete', 'cliente_dests_id_colonia', 'Colonia', '', [Validators.required], 6),
        Form.Field('text', 'cliente_dests_domicilio', 'Domicilio', '', [Validators.required], 6),
        Form.Field('select', 'cliente_dests_estado', 'Estado', '', [Validators.required], 6),
        Form.Field('select', 'cliente_dests_id_ciudad', 'Ciudad', '', [Validators.required], 6),
        Form.Field('select', 'cliente_dests_id_localidad', 'Localidad', '', [], 6)
      ], ['Guardar'], 'Destinatario'), this.formData
    )
    // if (this.props.match.params.tabId)
    //   this.LoadPreds(this.props.match.params.tabId)
    this.loadFormData();
  }

  componentDidUpdate(prevProps) {
    // console.log(prevProps)
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  formData = async (form) => {
    let id_cliente = (this.props.cliente) ? this.props.cliente : this.props.match.params.id;
    var Res = await Http.get(`cliente/form-generales?${(this.formEstado) ? `e=${this.formEstado}&` : ''}${(this.formCp) ? `cp=${this.formCp}&` : ''}${id_cliente ? `id_cliente=${id_cliente}` : ''}`);
    // var Res = await Http.get(`cliente/form-generales${(estado_id) ? `?e=${estado_id}` : ''}`);
    if (!Res.error) {
      var newForm = Form.FieldOptions(form, 'cliente_dests_estado', Res.data.estados, 'id', 'estado');
      if (Res.data.ciudades) newForm = Form.FieldOptions(newForm, 'cliente_dests_id_ciudad', Res.data.ciudades, 'id', 'ciudad');
      if (Res.data.localidades) newForm = Form.FieldOptions(newForm, 'cliente_dests_id_localidad', Res.data.ciudades, 'id_localidad', 'localidad');
      if (Res.data.direccion) {
        const { direccion } = Res.data;
        newForm = Form.FieldOptions(newForm, 'cliente_dests_id_colonia', direccion.colonias, 'id', 'colonia');
        newForm = Form.FieldOptions(newForm, 'cliente_dests_id_ciudad', direccion.ciudades, 'id', 'ciudad');
        newForm = Form.FieldOptions(newForm, 'cliente_dests_id_localidad', direccion.localidades, 'id_localidad', 'localidad');
        newForm = Form.Patch(newForm, { cliente_dests_estado: direccion.estado.id, cliente_dests_id_ciudad: direccion.ciudad.id });
        newForm = Form.FieldMod(newForm, 'cliente_dests_estado', 'Disabled', true);
        newForm = Form.FieldMod(newForm, 'cliente_dests_id_ciudad', 'Disabled', true);
      }
      if (Res.data.cliente_rfc_destrem && !newForm.Fields.some(f => f.Label === 'RFC')) {
        newForm.Fields.push(
          Form.Section('RFC'),
          Form.Field('radio', 'cliente_dests_fm', 'Persona Fisica / Moral', '', [], 6, [{ Label: 'Fisica', Value: "1" }, { Label: 'Moral', Value: "2" }]),
          Form.Field('text', 'cliente_dests_rfc', 'R.F.C.', '', [], 6),);
      }
      newForm = Form.ValueChange(newForm, { 
        cliente_dests_estado: this.estadoChange, 
        cliente_dests_cp: this.cpChange,
        cliente_dests_fm: this.cliFMChange,
       });
      return newForm;
    }
  }

  loadFormData = () => {
    if (this.props.match.params.tabId) {
      this.LoadPreds(this.props.match.params.tabId);
    }
  }

  LoadPreds = async (predId = null, callOnChange = true) => {
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`cliente-destinatario/one/${id}`);
    if (!Res.error) {
      if (Res.data) {
        // Res.data.cliente_dests_id_colonia = `${Res.data.cliente_dests_id_colonia}`;
        this.formCp = Res.data.cliente_dests_cp;
        let newForm = Form.Patch(this.state.FormData, {
          ...Res.data,
          'cliente_dests_fm': `${Res.data.cliente_dests_fm}`,
        })
        newForm = await this.formData(newForm)
        this.setState({ FormData: newForm });
      }
    }
    return Res.data;
  }


  cpChange = async (field) => {
    if (field.Value.length === 5) {
      this.formCp = field.Value;
      let newForm = this.state.FormData;
      newForm = Form.Patch(newForm, { cliente_dests_id_colonia: '' });
      this.setState({ FormData: await this.formData(newForm) });
    }
  }

  estadoChange = async (field) => {
    this.formEstado = field.Value;
    this.setState({ FormData: await this.formData(this.state.FormData, field.Value) })
  }

  onRouteChanged = () => {
    this.loadFormData();
  }

  onSubmit = async (i, vals) => {
    // vals.id_cliente = this.props.match.params.id;
    vals.id_cliente = (this.props.cliente) ? this.props.cliente : this.props.match.params.id;
    vals.id = this.props.match.params.tabId;
    // console.log(vals)
    if (vals.cliente_dests_id_colonia === '') {
      this.setState({ loading: false, sbMsg: `Colonia Invalida`, sbOpen: true });
    }
    let Res = await Http.post(`${this.config.saveUrl}`, vals);
    if (!Res.error) {
      this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true, FormData: Form.Reset(this.state.FormData) });
      if (this.props.back)
        this.props.history.push(`${this.config.backUrl}`)
      this.props.onSave(Res.data);
    } else {
      this.setState({ loading: false, sbMsg: `Error al guardar: ${Res.errMsg}`, sbOpen: true });
    }
  }

  cliFMChange = (field) =>  {
    const { FormData } = this.state;
    let validatorrfc = null
    if (Number(field.Value) === 1) {
      validatorrfc = Validators.rfc_fisica;
    } else {
      validatorrfc = Validators.rfc_moral;
    }

    const newFormData = Form.FieldMod(FormData, 'cliente_dests_rfc', 'Validators', [validatorrfc]);
    this.setState({ FormData: newFormData })
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Destinatario)
